var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateDataSystems = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 264,
    viewBox: "0 0 330 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.959 104.91C138.959 104.91 215.207 -14.5601 275.109 58.3173C326.85 121.269 273.946 155.388 261.949 120.138C252.876 93.4785 268.785 42.7567 294.234 34.4557C324.051 24.7279 335.865 56.7397 323.617 66.2469C308.699 77.8287 297.941 41.8632 295.994 2",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.341 184.414V218.586L102.417 234.866",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.344 221.947C130.201 221.947 131.705 220.442 131.705 218.586C131.705 216.73 130.201 215.225 128.344 215.225C126.488 215.225 124.983 216.73 124.983 218.586C124.983 220.442 126.488 221.947 128.344 221.947Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.991 227.777L83.3238 208.333C81.473 207.265 80.308 207.714 74.7119 212.362V231.872C78.1031 235.779 111.535 254.209 111.535 254.209C113.386 255.277 120.865 250.455 120.541 247.761L120.341 233.576C120.341 231.44 118.842 228.842 116.991 227.777Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.614 232.112L76.9 212.746C75.0465 211.683 73.55 212.551 73.5527 214.687L73.8109 228.872C73.8163 231.008 75.3211 233.603 77.1746 234.666L82.3615 237.645C82.4878 237.719 89.0066 241.462 89.1356 241.536L110.614 253.926C112.467 254.991 114.241 254.228 114.236 252.091L113.978 237.906C113.972 235.77 112.467 233.175 110.614 232.112Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5459 218.279L92.3507 214.1",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.732 231.594L116.537 227.415",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.721 231.747L114.037 236.934L114.238 253.95L120.704 249.406L120.921 247.382L120.721 231.747Z",
    fill: "#071A24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2315 76.0612C68.9981 75.7427 67.363 75.4258 67.709 75.2308L83.6007 65.6872C83.7325 65.6021 85.8496 64.0782 89.2408 66.0332L213.08 137.388C217.731 140.076 221.499 147.276 221.499 153.479V223.402C221.499 227.06 220.186 229.537 218.154 230.41L203.747 239.949C203.371 240.163 202.89 239.966 202.783 239.543C202.783 239.543 69.1135 162.32 69.1025 162.307L69.2343 76.0639L69.2315 76.0612Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9675 168.051L196.812 239.405C201.461 242.094 205.228 239.241 205.228 233.043V163.119C205.228 156.919 201.461 149.714 196.812 147.029L72.9675 75.6769C68.316 72.9887 64.5459 75.8389 64.5459 82.0418V151.963C64.5459 158.163 68.316 165.368 72.9675 168.051Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2105 154.06L194.322 221.532C195.838 222.4 197.071 221.472 197.071 219.448V159.761C197.071 157.74 195.838 155.389 194.322 154.513L77.2105 87.0445C75.6921 86.1713 74.4619 87.0966 74.4619 89.1259V148.813C74.4619 150.834 75.6893 153.184 77.2105 154.06V154.06Z",
    fill: "#5774FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2715 161.642L141.436 199.645",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.98 202.253L189.879 227.466",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9475 73.3427L90.8531 74.529C91.4709 74.8859 91.3913 75.512 90.6774 75.9239L89.3236 76.7037C88.607 77.1156 87.5278 77.1595 86.9073 76.7998L85.0044 75.6163C84.3838 75.2594 84.4634 74.6333 85.1773 74.2187L86.5311 73.4389C87.2477 73.027 88.3296 72.983 88.9475 73.34V73.3427Z",
    fill: "#071A24"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183.275 132.725L172.561 126.484C172.059 126.174 171.707 125.259 172.594 124.765L174.846 123.464C175.529 123.019 176.216 123.249 176.979 123.59L187.985 129.949C188.597 130.331 188.748 130.866 187.965 131.432L185.763 132.791C185.338 133.121 184.19 133.187 183.275 132.725Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.518 142.556L189.801 136.317C189.299 136.007 188.947 135.092 189.834 134.598L192.086 133.297C192.77 132.852 193.456 133.082 194.219 133.423L205.225 139.782C205.837 140.164 205.988 140.699 205.206 141.265L203.003 142.624C202.578 142.954 201.433 143.017 200.518 142.556Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.75 183.623C214.664 183.096 215.403 183.524 215.403 184.579C215.4 185.63 214.658 186.913 213.747 187.437C212.832 187.964 212.094 187.536 212.094 186.482C212.096 185.427 212.838 184.148 213.75 183.623Z",
    fill: "#071A24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M213.772 177.118C214.684 176.59 215.425 177.022 215.422 178.073C215.422 179.125 214.681 180.407 213.767 180.932C212.858 181.459 212.119 181.031 212.119 179.976C212.119 178.922 212.861 177.642 213.772 177.118Z",
    fill: "#071A24"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.79 170.613C214.698 170.086 215.437 170.517 215.437 171.568C215.437 172.62 214.696 173.902 213.784 174.427C212.872 174.954 212.131 174.526 212.134 173.471C212.134 172.42 212.875 171.137 213.79 170.613Z",
    fill: "#071A24"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M213.81 164.107C214.724 163.58 215.463 164.011 215.463 165.063C215.46 166.117 214.722 167.397 213.807 167.921C212.893 168.449 212.154 168.02 212.154 166.966C212.157 165.914 212.898 164.632 213.81 164.107Z",
    fill: "#071A24"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M213.831 157.603C214.745 157.075 215.484 157.504 215.481 158.555C215.481 159.61 214.739 160.887 213.828 161.414C212.913 161.941 212.175 161.51 212.175 160.456C212.175 159.404 212.916 158.122 213.828 157.6L213.831 157.603Z",
    fill: "#071A24"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M213.688 203.138C214.6 202.611 215.341 203.042 215.335 204.093C215.335 205.145 214.594 206.427 213.685 206.952C212.771 207.479 212.032 207.048 212.032 205.996C212.032 204.945 212.774 203.662 213.685 203.138H213.688Z",
    fill: "#071A24"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M213.706 196.633C214.617 196.106 215.356 196.534 215.356 197.589C215.356 198.643 214.615 199.923 213.703 200.447C212.791 200.975 212.05 200.546 212.053 199.492C212.053 198.44 212.794 197.158 213.706 196.633Z",
    fill: "#071A24"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M213.724 190.128C214.638 189.601 215.377 190.029 215.377 191.084C215.377 192.135 214.635 193.412 213.724 193.939C212.812 194.466 212.071 194.038 212.073 192.986C212.073 191.932 212.815 190.652 213.726 190.128H213.724Z",
    fill: "#071A24"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M213.647 216.148C214.562 215.62 215.3 216.049 215.3 217.1C215.3 218.152 214.559 219.434 213.647 219.959C212.736 220.486 211.994 220.055 211.997 219.003C211.997 217.949 212.738 216.669 213.65 216.145L213.647 216.148Z",
    fill: "#071A24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M213.665 209.643C214.579 209.115 215.318 209.544 215.318 210.598C215.318 211.65 214.576 212.932 213.665 213.457C212.75 213.984 212.012 213.553 212.012 212.501C212.012 211.447 212.756 210.167 213.665 209.643Z",
    fill: "#071A24"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.194 116.874L160.69 126.031",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M221.401 220.184L205.897 229.342",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9308 74.7625L88.9496 29.2935L32.7002 64.6165",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9479 32.654C90.8041 32.654 92.3088 31.1493 92.3088 29.2931C92.3088 27.4369 90.8041 25.9321 88.9479 25.9321C87.0917 25.9321 85.5869 27.4369 85.5869 29.2931C85.5869 31.1493 87.0917 32.654 88.9479 32.654Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6717 59.1142L11.3106 40.4085C9.45983 39.3404 8.09714 40.0456 2.50104 44.6943L2.49902 73.9961C5.89019 77.9035 39.9981 97.5676 39.9981 97.5676C41.8488 98.6358 48.6518 93.7665 48.3277 91.0728V65.6514C48.3277 63.5151 46.8285 60.9175 44.9778 59.8521L43.6717 59.1142Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1707 63.3554L4.89211 44.8211C2.67609 43.846 1.60003 44.8199 1.60277 46.9562L1.60254 72.1838C1.60803 74.3201 3.11277 76.9149 4.96624 77.9776L10.1532 80.9569C10.2795 81.031 16.7982 84.7736 16.9273 84.8478L38.6829 97.3443C40.5364 98.4097 42.0329 97.5392 42.0274 95.4029L41.9697 69.9816C41.9642 67.8453 40.4595 65.2504 38.606 64.1878L37.1707 63.3554Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5391 50.3511L20.3438 46.1719",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7188 63.666L44.5235 59.4868",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7128 63.8198L42.0293 69.0068V97.2619L48.4986 92.7175L48.7128 90.6937V63.8198Z",
    fill: "#071A24"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M151.124 142.962L145.734 139.68L140.948 143.305L146.3 146.432L151.124 142.962Z",
    fill: "#071A24"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M214.527 186.135L249.559 207.281L202.236 237.003",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M249.565 210.642C251.421 210.642 252.926 209.137 252.926 207.281C252.926 205.425 251.421 203.92 249.565 203.92C247.709 203.92 246.204 205.425 246.204 207.281C246.204 209.137 247.709 210.642 249.565 210.642Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M215.499 224.05L181.826 204.61C179.975 203.541 178.476 204.409 172.88 209.058V239.223C176.271 243.13 210.494 261.843 210.494 261.843C212.345 262.911 219.167 257.968 218.843 255.274V229.852C218.843 227.716 217.349 225.116 215.499 224.05Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M209.114 228.389L175.4 209.022C173.546 207.959 172.05 208.827 172.053 210.963L172.11 236.385C172.116 238.521 173.621 241.116 175.474 242.178L180.661 245.158C180.787 245.232 187.306 248.975 187.435 249.049L209.191 261.545C211.044 262.611 212.541 261.74 212.535 259.604L212.478 234.182C212.472 232.046 210.967 229.451 209.114 228.389Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M185.047 214.552L190.852 210.376",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M209.232 227.867L215.037 223.691",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M219.221 228.021L212.537 233.211V261.463L219.006 256.919L219.221 254.898V228.021Z",
    fill: "#071A24"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M179.707 224.498C179.707 224.498 182.198 234.831 190.586 238.521C200.038 242.681 207.976 237.747 207.976 237.747",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M205.536 244.449L205.107 239.724",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M176.609 228.897L180.47 228.111",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M177.875 234.034L182.617 231.887",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M181.17 237.955L184.869 234.866",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M185.878 241.302L188.281 238.202",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M191.668 243.392L193.115 239.787",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.37 244.449L199.144 240.388",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6024 80.0314C35.6731 79.2172 35.3996 77.056 33.9915 75.2042C32.5834 73.3524 30.5739 72.5113 29.5032 73.3256C28.4325 74.1398 28.706 76.301 30.1141 78.1527C31.5222 80.0045 33.5317 80.8456 34.6024 80.0314Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1346 74.2306C25.2054 73.4164 24.9319 71.2552 23.5238 69.4034C22.1157 67.5517 20.1062 66.7106 19.0354 67.5248C17.9647 68.339 18.2382 70.5002 19.6463 72.3519C21.0544 74.2037 23.0639 75.0448 24.1346 74.2306Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6717 68.4254C14.7425 67.6112 14.469 65.45 13.0609 63.5982C11.6528 61.7465 9.64326 60.9054 8.57253 61.7196C7.50179 62.5338 7.77529 64.695 9.1834 66.5468C10.5915 68.3985 12.601 69.2396 13.6717 68.4254Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3486 238.216L98.937 237.066L95.0818 230.322",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6182 241.102L104.207 239.952L100.351 233.208",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7998 224.028L84.7207 233.079",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8361 222.205L81.7598 231.258",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8772 227.738L90.8008 236.788",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9131 225.915L87.834 234.968",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M123.115 138.854L126.814 155.368L151.236 137.379",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M101.017 150.417L161.335 185.168C162.115 185.616 162.75 185.138 162.75 184.095V153.352C162.75 152.311 162.115 151.1 161.335 150.65L101.017 115.901C100.234 115.451 99.6025 115.928 99.6025 116.972V147.715C99.6025 148.755 100.234 149.966 101.017 150.417V150.417Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M251.461 139.442C244.278 139.532 238.461 140.329 238.485 142.971C238.516 146.336 244.338 146.262 251.522 146.172C258.705 146.082 264.525 145.687 264.498 142.643C264.468 139.278 258.645 139.352 251.461 139.442Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M231.92 113.867C226.868 120.648 223.376 126.589 225.593 128.224C228.414 130.303 232.51 124.807 237.565 118.026C242.617 111.245 246.445 105.551 243.892 103.669C241.071 101.589 236.975 107.086 231.92 113.867Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M249.29 123.431C240.141 128.422 233.012 133.043 234.064 135.16C235.404 137.854 242.82 133.809 251.967 128.819C261.116 123.829 268.405 119.529 267.193 117.09C265.853 114.396 258.436 118.441 249.287 123.431H249.29Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M246.33 155.858C241.86 154.603 238.069 154.05 237.46 155.75C236.684 157.914 240.308 158.931 244.778 160.185C249.248 161.44 252.948 162.252 253.648 160.293C254.425 158.129 250.8 157.112 246.33 155.858Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6361 169.362C43.8196 169.287 49.6368 168.622 49.6121 166.421C49.5818 163.617 43.7591 163.678 36.5756 163.753C29.3921 163.828 23.5722 164.158 23.5997 166.694C23.6299 169.498 29.4526 169.437 36.6361 169.362Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1768 195.169C61.2289 188.539 64.721 182.729 62.5038 181.131C59.6828 179.097 55.5868 184.472 50.5319 191.102C45.4798 197.733 41.6522 203.3 44.2048 205.14C47.0259 207.174 51.1218 201.799 56.1768 195.169Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M38.241 185.779C47.3903 181.074 54.5187 176.716 53.4668 174.721C52.1269 172.181 44.7106 175.995 35.564 180.7C26.4147 185.404 19.1257 189.459 20.3383 191.758C21.6781 194.298 29.0945 190.484 38.2438 185.779H38.241Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2019 153.876C45.6718 155.34 49.4631 155.986 50.0723 154.003C50.8484 151.477 47.224 150.291 42.754 148.828C38.284 147.364 34.5845 146.417 33.8835 148.701C33.1075 151.227 36.7319 152.412 41.2019 153.876Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4187 258.313C20.8071 256.667 19.7879 255.018 18.1422 254.63C16.4965 254.242 14.8476 255.261 14.4592 256.906C14.0707 258.552 15.0899 260.201 16.7356 260.59C18.3813 260.978 20.0303 259.959 20.4187 258.313Z",
    fill: "#071A24"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M267.414 255.175C267.802 253.53 266.783 251.881 265.137 251.492C263.492 251.104 261.843 252.123 261.454 253.769C261.066 255.414 262.085 257.063 263.731 257.452C265.376 257.84 267.025 256.821 267.414 255.175Z",
    fill: "#071A24"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M249.167 64.4746C249.555 62.829 248.536 61.18 246.89 60.7916C245.245 60.4031 243.596 61.4224 243.207 63.0681C242.819 64.7138 243.838 66.3627 245.484 66.7511C247.129 67.1396 248.778 66.1203 249.167 64.4746Z",
    fill: "#071A24"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M131.317 38.2173C131.706 36.5716 130.686 34.9227 129.041 34.5342C127.395 34.1458 125.746 35.165 125.358 36.8107C124.969 38.4564 125.988 40.1054 127.634 40.4938C129.28 40.8822 130.929 39.863 131.317 38.2173Z",
    fill: "#071A24"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M316.182 216.198C309.712 217.807 308.164 219.8 307.067 228.928C307.001 229.46 306.252 229.46 306.187 228.928C305.092 219.797 303.541 217.807 297.071 216.198C296.617 216.086 296.617 215.423 297.071 215.311C303.541 213.702 305.089 211.71 306.187 202.582C306.252 202.05 307.001 202.05 307.067 202.582C308.161 211.713 309.712 213.702 316.182 215.311C316.636 215.423 316.636 216.086 316.182 216.198Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateDataSystems);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateDataSystems.6c22bca045f38c6ac984446421fd51fd.svg";